import PrivacyPolicy from './PrivacyPolicy';

export { PrivacyPolicy };
export default PrivacyPolicy;
